"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.hideSnackbar = exports.showSnackbarMessageWithHourGlassButton = exports.showSnackbarMessage = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _SnackbarHelper = _interopRequireDefault(require("./SnackbarHelper.scss"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _HourglassEmpty = _interopRequireDefault(require("@material-ui/icons/HourglassEmpty"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var INSTANCE = null;
var DEFAULT_DISPLAY_TIME = 6000; // 6sec
// const DEFAULT_DISPLAY_TIME = null

var currentMessage = null;
var currentShowCloseButton = true;
var currentShowHourGlassButton = false;
var currentlyOpen = false;
var hidingTimer = null;

var SnackbarHelper = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SnackbarHelper, _React$Component);

  var _super = _createSuper(SnackbarHelper);

  function SnackbarHelper(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, SnackbarHelper);
    _this = _super.call(this, props);
    INSTANCE = (0, _assertThisInitialized2["default"])(_this);
    return _this;
  }

  (0, _createClass2["default"])(SnackbarHelper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var buttons = [];

      if (currentShowCloseButton) {
        buttons.push( /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
          key: "close",
          "aria-label": "Close",
          color: "inherit",
          onClick: function onClick() {
            currentlyOpen = false;

            _this2.forceUpdate();
          }
        }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)));
      } else if (currentShowHourGlassButton) {
        buttons.push( /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
          key: "hourglass",
          color: "inherit"
        }, /*#__PURE__*/_react["default"].createElement(_HourglassEmpty["default"], null)));
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        key: "SNACKBAR",
        className: _SnackbarHelper["default"].outerFrame
      }, /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], {
        open: currentlyOpen,
        message: currentMessage,
        action: buttons
      }));
    }
  }]);
  return SnackbarHelper;
}(_react["default"].Component);

var showSnackbarMessage = function showSnackbarMessage(message) {
  var showCloseButton = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var autoHide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  clearTimeout(hidingTimer);
  currentMessage = message;
  currentShowCloseButton = showCloseButton;
  currentShowHourGlassButton = false;
  currentlyOpen = true;

  if (INSTANCE) {
    INSTANCE.forceUpdate();
  }

  if (autoHide) {
    hidingTimer = setTimeout(function () {
      currentlyOpen = false;

      if (INSTANCE) {
        INSTANCE.forceUpdate();
      }
    }, DEFAULT_DISPLAY_TIME);
  }
};

exports.showSnackbarMessage = showSnackbarMessage;

var showSnackbarMessageWithHourGlassButton = function showSnackbarMessageWithHourGlassButton(message) {
  var autoHide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  clearTimeout(hidingTimer);
  currentMessage = message;
  currentShowCloseButton = false;
  currentShowHourGlassButton = true;
  currentlyOpen = true;

  if (INSTANCE) {
    INSTANCE.forceUpdate();
  }

  if (autoHide) {
    hidingTimer = setTimeout(function () {
      currentlyOpen = false;

      if (INSTANCE) {
        INSTANCE.forceUpdate();
      }
    }, DEFAULT_DISPLAY_TIME);
  }
};

exports.showSnackbarMessageWithHourGlassButton = showSnackbarMessageWithHourGlassButton;

var hideSnackbar = function hideSnackbar() {
  clearTimeout(hidingTimer);
  currentlyOpen = false;

  if (INSTANCE) {
    INSTANCE.forceUpdate();
  }
};

exports.hideSnackbar = hideSnackbar;
var _default = SnackbarHelper;
exports["default"] = _default;